import { createSelector } from 'reselect'
import { IRootReducer } from '../../types/reducerTypes'

const miscUiReducer = (state: IRootReducer) => state.miscUI

export const selectHeaderBackground = createSelector(
  miscUiReducer,
  (reducer) => reducer.headerBgUrl,
)

export const selectHideBurger = createSelector(
  miscUiReducer,
  (reducer) => reducer.hideBurger,
)

export const selectPageBackground = createSelector(
  miscUiReducer,
  (reducer) => reducer.pageBgUrl,
)

export const selectIsDarkThemeState = createSelector(
  miscUiReducer,
  (reducer) => reducer.isDarkTheme,
)

export const selectTopBarContent = createSelector(
  miscUiReducer,
  (reducer) => reducer.topBarContent,
)

export const selectTopBarUrlLink = createSelector(
  miscUiReducer,
  (reducer) => reducer.topBarUrlLink,
)

export const selectTopBarRightContent = createSelector(
  miscUiReducer,
  (reducer) => reducer.topBarRightContent,
)

export const selectTopBarHideMobile = createSelector(
  miscUiReducer,
  (reducer) => reducer.topBarHideMobile,
)

export const selectAllPoolsLastPage = createSelector(
  miscUiReducer,
  (reducer) => reducer.allPoolsLastPage,
)

export const selectShouldScrollToProjects = createSelector(
  miscUiReducer,
  (reducer) => reducer.shouldScrollToProjects,
)

export const selectShouldResetRewardsNotification = createSelector(
  miscUiReducer,
  (reducer) => reducer.shouldResetRewardsNotification,
)

export const selectMultiStepTxTotalSteps = createSelector(
  miscUiReducer,
  (reducer) => reducer.multiStepTxTotalSteps,
)

export const selectMultiStepTxCurrentStep = createSelector(
  miscUiReducer,
  (reducer) => reducer.multiStepTxCurrentStep,
)

export const selectAllocationOpenTabs = createSelector(
  miscUiReducer,
  (reducer) => reducer.allocationOpenTabs,
)

export const selectResetAllClaims = createSelector(
  miscUiReducer,
  (reducer) => reducer.resetAllClaims,
)

export const selectAllocationIndexClaiming = createSelector(
  miscUiReducer,
  (reducer) => reducer.allocationIndexClaiming,
)

export const selectInvestAmountForCheckout = createSelector(
  miscUiReducer,
  (reducer) => reducer.investmentAmountForCheckout,
)

export const selectIsCheckoutScreen = createSelector(
  miscUiReducer,
  (reducer) => reducer.isCheckoutScreen,
)
export const selectPlanForCheckout = createSelector(
  miscUiReducer,
  (reducer) => reducer.planForCheckout,
)
export const selectHasCompletedPlusCheckout = createSelector(
  miscUiReducer,
  (reducer) => reducer.hasCompletedPlusCheckout,
)

export const selectShowRadialGlow = createSelector(
  miscUiReducer,
  (reducer) => reducer.showRadialGlow,
)

export const selectRewardsAmount = createSelector(
  miscUiReducer,
  (reducer) => reducer.rewardsAmount,
)

export const selectHeaderHeight = createSelector(
  miscUiReducer,
  (reducer) => reducer.headerHeight,
)

export const selectShowHeaderGradient = createSelector(
  miscUiReducer,
  (reducer) => reducer.showHeaderGradient,
)
export const selectShowDashboardHeaderGradient = createSelector(
  miscUiReducer,
  (reducer) => reducer.showDashboardHeaderGradient,
)

export const selectIsLaunch = createSelector(
  miscUiReducer,
  (reducer) => reducer.isLaunch,
)

export const selectIsMemecoins = createSelector(
  miscUiReducer,
  (reducer) => reducer.isMemecoins,
)

export const selectMemecoinsSearchQuery = createSelector(
  miscUiReducer,
  (reducer) => reducer.memecoinsSearchQuery,
)

export const selectIsDrops = createSelector(
  miscUiReducer,
  (reducer) => reducer.isDrops,
)

export const selectReferralProject = createSelector(
  miscUiReducer,
  (reducer) => reducer.referralProject,
)

export const selectTwitterWarningNotice = createSelector(
  miscUiReducer,
  (reducer) => reducer.twitterWarningNotice,
)

export const selectDiscordWarningNotice = createSelector(
  miscUiReducer,
  (reducer) => reducer.discordWarningNotice,
)

export const selectBottomNavButton = createSelector(
  miscUiReducer,
  (reducer) => reducer.bottomNavButton,
)

export const selectDismissableModal = createSelector(
  miscUiReducer,
  (reducer) => reducer.dismissableModal,
)
